import { Typography } from "@material-ui/core"
import { CustomIcon } from "ams-ui-reactkit"
import { getRandomNumber } from "../../utils/Utils"
import './IconsList.scss'

const IconsList = ({ list, onClick }: any) => {
    return (
        <div>
            <div className="iconList">
                {list && list.length > 0 && list.map((item: any, pageIndex: any) => {
                    return <div key={pageIndex + getRandomNumber()} className={`iconSingle ${item.action ? "highlightIcon" : ""}`} onClick={() => item.action && onClick(item.action)}>
                        <div >
                            <CustomIcon iconName={item.icon} />
                        </div>
                        <div className="itemName">
                            <Typography variant="caption" className="lh-1">
                                {item.label}
                            </Typography>
                        </div>
                    </div>
                })}

            </div>
        </div>
    )
}

export default IconsList